exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon__heading{font-weight:400;color:#6d6e71}.icons-wrapper{-ms-flex-wrap:wrap;flex-wrap:wrap}.icons-wrapper,.icons-wrapper>div{display:-webkit-box;display:-ms-flexbox;display:flex}.icons-wrapper>div{margin:15px;text-align:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-width:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bf462b8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo/ui-kit/phd/phd-icons.vue
// module id = 1127
// module chunks = 0